module.exports = __webpack_public_path__ + "static/media/archeology.02a19f05.svg";